import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import LeadInbox from '~/javascript/components/landing_pages/lead_inbox.vue'
import CallSettings from '~/javascript/components/landing_pages/call_settings.vue'

/**
 * L12 ERB -> Vue bridge for the native Made.ly lead inbox and call settings.
 * ERB passes only the authorized workspace id, the native Ajax base and the
 * CSRF token; the components read and write through the Rails Ajax API.
 */
export default class extends Controller {
  static values = {
    workspaceId: String,
    view: { type: String, default: 'inbox' },
    apiBase: String,
    csrfToken: String
  }

  connect() {
    const component = this.viewValue === 'settings' ? CallSettings : LeadInbox
    this.vue = createApp(component, {
      workspaceId: this.workspaceIdValue,
      apiBase: this.apiBaseValue || undefined,
      csrfToken: this.csrfTokenValue || document.querySelector('meta[name="csrf-token"]')?.content || ''
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
    this.vue = null
  }
}
